import { Component } from "react";
import axios from "axios";

const URL_API = "/api";

class Trades extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newTradeItemName: "",
            newTradeItemPrice: "",
            stonks: [],
            lastTimeRequestNumber: 0,
            currentRequstNumber: 0,
            updating: false,
        }

        this.stonks = {}
        this.stonksPrices = {}

    }

    nameChange = (value) => {
        this.setState({ newTradeItemName: value })
    }

    priceChange = (e) => {
        this.setState({ newTradeItemPrice: e.target.value })
    }

    handleClick = () => {
        const { newTradeItemName, newTradeItemPrice } = this.state;
        console.log(newTradeItemName, newTradeItemPrice)
        let newTrades = this.props.trades;
        newTrades.key = Math.random();
        newTrades.push({ name: newTradeItemName, platinum: newTradeItemPrice, key: Math.random() })
        this.props.updateTrades(newTrades);
    }

    doNextPromise = (bds) => {
        this.stonks = {};
        this.stonksPrices = {};
        this.pendingSets = bds.length;
        this.setState({ stonks: [], currentRequstNumber: 0, lastTimeRequestNumber: bds.length });

        const slugs = bds.map(set => set.url_name);
        axios.post(URL_API + '/items/bulk', { slugs })
            .then(response => {
                const missing = [];
                bds.forEach(set => {
                    const item = response.data[set.url_name];
                    if (item) {
                        this.stonks[set.url_name] = { items_in_set: item.items_in_set || [], ...set };
                        this.fetchSetOrders(set.url_name);
                    } else {
                        missing.push(set);
                    }
                });
                // Individual fallback for missing sets
                missing.forEach(set => {
                    axios.get(URL_API + '/items/' + set.url_name)
                        .then(x => {
                            const item = x.data.payload ? x.data.payload.item : null;
                            this.stonks[set.url_name] = { items_in_set: item ? item.items_in_set : [], ...set };
                            this.fetchSetOrders(set.url_name);
                        })
                        .catch(() => {
                            this.stonks[set.url_name] = { items_in_set: [], ...set };
                            this.fetchSetOrders(set.url_name);
                        });
                });
            })
            .catch(err => {
                console.log('bulk items error', err);
                this.setState({ updating: false });
            });
    }

    fetchSetOrders = (setSlug) => {
        const set = this.stonks[setSlug];
        if (!set) return;

        const parts = (set.items_in_set || []).filter(item => item.url_name !== setSlug);
        const allSlugs = [setSlug, ...parts.map(i => i.url_name)];

        axios.post(URL_API + '/items/orders/bulk', { slugs: allSlugs })
            .then(response => {
                const missing = [];
                allSlugs.forEach(slug => {
                    if (response.data[slug] != null) {
                        this.stonksPrices[slug] = response.data[slug];
                    } else {
                        missing.push(slug);
                    }
                });

                if (missing.length === 0) {
                    this.processSetComplete(setSlug);
                    return;
                }

                let remaining = missing.length;
                missing.forEach(slug => {
                    axios.get(URL_API + '/items/' + slug + '/orders')
                        .then(x => {
                            this.stonksPrices[slug] = x.data.payload ? x.data.payload.orders : [];
                        })
                        .catch(() => { this.stonksPrices[slug] = []; })
                        .then(() => { if (--remaining === 0) this.processSetComplete(setSlug); });
                });
            })
            .catch(() => this.processSetComplete(setSlug));
    }

    processSetComplete = (setSlug) => {
        const set = this.stonks[setSlug];
        if (!set) return;

        let somme = 0;
        const setOrders = this.stonksPrices[setSlug] || [];
        const items_in_set = (set.items_in_set || [])
            .filter(item => item.url_name !== setSlug)
            .map(item => {
                item.orders = this.stonksPrices[item.url_name] || [];
                somme += (item.orders[0] ? item.orders[0].platinum : 0) * (item.quantity_for_set || 1);
                return item;
            });

        const updatedSet = {
            ...set,
            orders: setOrders,
            items_in_set,
            total: somme,
            dif: setOrders[0] ? setOrders[0].platinum - somme : null,
        };
        this.stonks[setSlug] = updatedSet;

        this.pendingSets--;
        const done = this.pendingSets === 0;

        this.setState(prev => {
            const newStonks = prev.stonks.filter(s => s.url_name !== setSlug);
            newStonks.push(updatedSet);
            newStonks.sort((a, b) => (b.dif || 0) - (a.dif || 0));
            if (done) localStorage.setItem("lastStonks", JSON.stringify(newStonks));
            return {
                stonks: newStonks,
                currentRequstNumber: prev.currentRequstNumber + 1,
                updating: !done,
            };
        });
    }

    updateSetAnalyse = () => {
        this.setState({ currentRequstNumber: 0, updating: true })
        axios.get(URL_API + "/items")
            .then(response => {
                const bds = response.data.payload.items.filter(item => item.item_name.includes("Prime Set"));
                this.doNextPromise(bds.slice());
            })
            .catch(err => {
                console.log(err)
                this.setState({ updating: false })
            })
    }

    componentDidMount = () => {
        let lastTimeRequestNumber = localStorage.getItem("lastTimeRequestNumber")
        if (lastTimeRequestNumber) {
            console.log("lastTimeRequestNumber", lastTimeRequestNumber)
            this.setState({ lastTimeRequestNumber: Number(lastTimeRequestNumber) })
        }
        let lastStonks
        try{
            lastStonks = JSON.parse(localStorage.getItem("lastStonks"));
        } catch{
            localStorage.removeItem("lastStonks")
        }
        
        if (lastStonks) {
            console.log("lastStonks", lastStonks)
            this.setState({ stonks: lastStonks })
        } else {
            this.updateSetAnalyse();
        }


    }

    render() {
        const { stonks, lastTimeRequestNumber, currentRequstNumber, updating } = this.state;
        const total = lastTimeRequestNumber || 1;
        let currentProgress = Math.min(100, (100 * currentRequstNumber / total));

        return (
            <div className="card border-dark trades mt-4" style={{height:"600px"}}>
                <div className="d-flex justify-content-between">
                    <h5 className="m-2">
                        <strong>Stonks</strong>
                    </h5>
                    {updating ?
                        <div className="progress w-100 m-2 mt-3">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: Math.max(currentProgress, 3) + "%" }}
                                aria-valuenow={currentProgress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                {currentRequstNumber} / {lastTimeRequestNumber}
                            </div>
                        </div>
                        : null
                    }
                    <button style={{ boxShadow: "none", outline: "none" }} disabled={updating} className="btn-sm btn-secondary m-1" onClick={this.updateSetAnalyse}>Actualiser</button>
                </div>
                <div className="card-body m-0 p-2" style={{overflow: "auto"}}>
                    <div className="">
                        {
                            stonks.length !== 0 &&
                            <div className=""  >
                                {
                                    stonks.map((set, i) => {
                                        const orders = set.orders
                                        let prices = (orders[0] != null ? orders[0].platinum : "") + " " + (orders[1] != null ? orders[1].platinum : "") + " " + (orders[2] != null ? orders[2].platinum : "") + " " + (orders[3] != null ? orders[3].platinum : "") + " " + (orders[4] != null ? orders[4].platinum : "")
                                        return <div key={set.id || i} className="border-dark mb-2 d-flex flex-row">
                                            <div className="m-1 col-3">
                                                <div className="m-1">
                                                    <a style={{ maxWidth: "180px", color: "#5f66d9",textDecoration:"none" }} rel="noopener noreferrer" target='_blank' href={"https://warframe.market/items/" + set.url_name}>{set.item_name}</a>
                                                </div>
                                                <div className="m-1">{prices}</div>
                                                <div className="m-1">Total : {set.total} Dif : {set.dif}</div>
                                            </div>
                                            <div className="">
                                                {
                                                    set.items_in_set.map((item, j) => {
                                                        let itemName = item.item_name.replace(set.item_name.replace(" Set", ''), '').trim().split(' ')[0];
                                                        if (item.quantity_for_set !== 1) {
                                                            itemName = item.quantity_for_set + "x " + itemName
                                                        }
                                                        const orders = item.orders
                                                        let prices = (orders[0] != null ? orders[0].platinum : "") + " " + (orders[1] != null ? orders[1].platinum : "") + " " + (orders[2] != null ? orders[2].platinum : "") + " " + (orders[3] != null ? orders[3].platinum : "") + " " + (orders[4] != null ? orders[4].platinum : "")
                                                        return <div key={item.id || j} className="m-1 d-flex">

                                                            <a className="mr-2" style={{ maxWidth: "180px", color: "#5f66d9",textDecoration:"none" }} rel="noopener noreferrer" target='_blank' href={"https://warframe.market/items/" + item.url_name}>{itemName} </a>
                                                            <div>{prices}</div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    })
                                }
                            </div>



                            /*
                                trades.length !== 0 && <div key={trades.key} className="card card-custom mb-1" style={{ backgroundColor: "rgb(52, 58, 64)" }}>
                                    <table className="">
                                        <tbody>
                                            {
                                                trades.map(trade => {
                                                    return <tr key={trade.key} className="" >
    
                                                        <td className="pr-0" style={{maxWidth:"200px"}} >{trade.name}</td>
                                                        <td className="pl-1">{trade.platinum}</td>
                                                        <td className="">200 200 200 200 200</td>
    
                                                        <td style={{maxWidth:"50px"}} className="form-group  mr-3 m-0 p-0">
                                                            <input type="text" className=" p-1 form-control" />
                                                        </td>
                                                        <td className="p-0">
                                                            <button style={{ boxShadow: "none", outline: "none" }} className="custom-button btn btn-secondary ml-1">Sold</button>
                                                        </td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>*/
                        }

                    </div>
                </div>
            </div>
        )
    }
}


export default Trades;